
import Component from "vue-class-component";
import Vue from "vue";
import BarcodeSystemModule  from "@/store/modules/barcodeSystem";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { DamageCodeResource } from "../../models/api/barcodeSystem/damageCode";
import { EditDamageCodeModel } from "@/models/ui/editDamageCode";
import { formatBool } from "@/utils";

const barcodeSystemModuleState = getModule(BarcodeSystemModule);
import notifications from "../../lib/notifications";
@Component({
  components: {
    Select
  }
})
export default class DamageCodes extends Vue {
  damageCodes: DamageCodeResource[] = null;
  damageCodeFilter: string = null;
  loading: boolean = false;
  editDamageCodeModel: EditDamageCodeModel = null;

  async created() {
    await this.loadDamageCodes();
  }

  async loadDamageCodes() {
    this.loading = true;
    await barcodeSystemModuleState.loadDamageCodes();
    this.damageCodes = barcodeSystemModuleState.damageCodes;
    this.loading = false;
  }

  get filteredDamageCodes() {
    if(this.damageCodeFilter)
      return this.damageCodes.filter(x =>(x.description && x.description.toUpperCase().startsWith(this.damageCodeFilter.toUpperCase()) || 
                                           x.code.toUpperCase().startsWith(this.damageCodeFilter.toUpperCase())));
    else
      return this.damageCodes;
  }

  formatBool(val: string)
  {
    return formatBool(val);
  }

  descriptionState() {
    return this.editDamageCodeModel.description ? null : false;
  }

  codeState() {
    return this.editDamageCodeModel.code ? null : false;
  }

  validateForm() {
    if(this.descriptionState() === false) return false;
    if(this.codeState() === false) return false;
    return true;
  }

  goBack() {
    this.$router.back();
  }

  async saveDamageCode() {
    if(!this.validateForm()) return;
    try {
      this.editDamageCodeModel.saving = true;
      if (this.editDamageCodeModel.isNew) {
        await barcodeSystemModuleState.createDamageCode(this.editDamageCodeModel.toCreateDamageCodeRequest());
      } else {
        await barcodeSystemModuleState.updateDamageCode(this.editDamageCodeModel.toUpdateDamageCodeRequest());
      }
      notifications.success("Damage Code Saved", "Successfully saved damage code");
      await this.loadDamageCodes();
      this.closeEditModal();
    } catch (ex) {
      notifications.error("Save Damage Code", "Failed to save damage code", ex);
      this.editDamageCodeModel.saving = false;
    }
  }  
  
  closeEditModal() {
    this.editDamageCodeModel.visible = false;
    this.editDamageCodeModel = null;
  }

  async editDamageCode(item: DamageCodeResource = null) {
    this.editDamageCodeModel = new EditDamageCodeModel();
    this.editDamageCodeModel.visible = true;

    if (item) {
      const damageCode = await barcodeSystemModuleState.getDamageCode(item.code);
      this.editDamageCodeModel.loading = false;
      this.editDamageCodeModel.isNew = false;
      this.$set(this.editDamageCodeModel, 'code', damageCode.code);
      this.$set(this.editDamageCodeModel, 'description', damageCode.description);
    } else {
      this.editDamageCodeModel.showForNewDamageCode();
    }
  }
}
